
/** Clamp a value into the inclusive [lo, hi] range. */
export const clamp = (v: number, lo: number, hi: number): number =>
  Math.min(hi, Math.max(lo, v));

/** Round to two decimal places. */
export const round2 = (v: number): number => Math.round(v * 100) / 100;


/** True when the Office document context is available (add-in attached). */
export function hasOffice(): boolean {
  return typeof Office !== "undefined" && !!Office.context && !!Office.context.document;
}

/** True when running in the PowerPoint host (the `PowerPoint` global exists). */
export function hasPpt(): boolean {
  return (globalThis as { PowerPoint?: unknown }).PowerPoint !== undefined;
}

/** The PowerPoint host namespace (call only after `hasPpt()` is true). */
export function ppt(): typeof PowerPoint {
  return (globalThis as { PowerPoint: typeof PowerPoint }).PowerPoint;
}
 